import { Stage } from "./Stage";
import { Speech } from "./TalkPanel";

export class Stage4 extends Stage {
    constructor() {
        super();
        this.pushCheckPoint(50, 50);
        this.pushPlayer(50, 50);
        this.asCameraCenter();

        //外壁
        this.pushWall(-800, -400, 600, 300);
        this.pushWall(-200, -400, 200, 200);
        this.pushWall(-800, 100, 600, 300);
        this.pushWall(-200, 200, 600, 200);
        this.pushFakePanel(-800, -100, 600, 200);
        this.pushWall(400, -200, 800, 600);
        this.pushWall(200, -400, 800, 200);
        this.pushWall(1000, -600, 600, 400);
        this.pushWall(1000, -1000, 400, 400);
        this.pushWall(200, -800, 600, 200);
        this.pushWall(200, -1200, 1200, 200);
        this.pushWall(200, -1600, 200, 400);
        this.pushWall(500, -1600, 300, 400);
        this.pushWall(900, -1600, 1100, 200);
        this.pushWall(1600, -1200, 400, 400);
        this.pushWall(1200, 0, 600, 200);
        this.pushWall(1800, -600, 600, 800);
        this.pushFakePanel(1600, -600, 200, 400);
        this.pushWall(2200, -1000, 200, 400);
        this.pushWall(2200, -1200, 600, 200);
        this.pushWall(2600, -1400, 200, 200);
        this.pushWall(2200, -1600, 600, 200);
        this.pushWall(2200, -3000, 200, 1600);
        this.pushWall(2000, -2200, 200, 200);
        this.pushWall(1600, -2200, 400, 400);
        this.pushWall(1600, -2900, 500, 600);
        this.pushSquare(1400, -2900, 200, 700);
        this.pushWall(1200, -2200, 200, 600);
        this.pushWall(1600, -1200, 400, 400);
        this.pushSquare(1600, -1400, 200, 200);
        this.pushSquare(1800, -1400, 400, 200);
        this.pushWall(500, -2000, 700, 200);
        this.pushWall(450, -2300, 950, 100);
        this.pushWall(450, -2800, 550, 500);
        this.pushWall(0, -3000, 1000, 200);
        this.pushWall(600, -3200, 600, 200);
        this.pushWall(1400, -3200, 1000, 200);
        this.pushWall(1600, -3400, 200, 200);
        this.pushWall(1800, -3400, 200, 200);
        this.pushWall(0, -3600, 2000, 200);
        this.pushWall(-400, -3000, 400, 400);
        this.pushWall(-200, -2600, 200, 1000);
        this.pushWall(-400, -2000, 200, 800);
        this.pushWall(-600, -1200, 400, 200);
        this.pushWall(-200, -1400, 200, 400);
        this.pushWall(200, -2600, 150, 400);
        this.pushWall(200, -2200, 200, 400);
        this.pushSquare(400, -2600, 50, 400);
        this.pushSquare(400, -2200, 100, 200);
        this.pushSquare(400, -2000, 100, 400);
        this.pushWall(1000, -1800, 200, 200);
        // this.pushSquare(600, -3400, 200, 200);
        this.pushSquare(0, -3200, 200, 200);
        this.pushSquare(-400, -3200, 200, 200);
        this.pushSquare(-1200, -2800, 600, 600);
        this.pushFakePanel(-1400, -3200, 400, 200);
        this.pushFakePanel(-1000, -3000, 200, 200);
        this.pushFakePanel(-600, -2600, 400, 200);
        this.pushWall(-800, -3000, 200, 200);
        this.pushWall(-600, -2400, 200, 600);
        this.pushWall(-800, -2200, 200, 400);
        this.pushWall(-1000, -2000, 200, 200);
        this.pushWall(-1200, -2000, 200, 600);
        this.pushWall(-1400, -3400, 1600, 200);
        this.pushWall(-1400, -3000, 400, 200);
        this.pushWall(-1600, -3400, 200, 600);
        this.pushWall(-2000, -2800, 600, 200);
        this.pushWall(-2200, -2800, 200, 1000);
        this.pushWall(-2000, -2000, 600, 200);
        this.pushWall(-2000, -1800, 200, 1200);
        this.pushWall(-1800, -900, 200, 300);
        this.pushWall(-1600, -800, 800, 200);
        this.pushWall(-1600, -1400, 600, 300);
        this.pushWall(-1400, -1100, 400, 100);
        this.pushWall(-1000, -1200, 200, 200);
        this.pushWall(-1000, -600, 200, 200);
        this.pushWall(-1400, -400, 600, 200);
        this.pushWall(-1400, -200, 200, 400);
        this.pushWall(-1400, 200, 600, 200);
        this.pushWall(-600, -800, 600, 200);
        this.pushSquare(-800, -1000, 1600, 200);

        this.pushSignboard(-150, -1550, [
            new Speech({
                content: "ここは押せる壁や通れる壁が多いです。",
                speakerName: "看板",
            }),
            new Speech({
                content: "押せるところはどんどん押して、通れるところはどんどん通りましょう。",
                speakerName: "看板",
            }),
            new Speech({
                content: "どこが押せるか分かればいいんだが。",
            }),
            new Speech({
                content: "道の形にも注目したほうがいいかも。",
                speakerName: "謎の声",
            }),
        ]);
        this.pushSignboard(1050, -2150, [
            new Speech({
                content: '<font style="color:#dd0000">自分の大切なものは誰しも持っているものだ。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(1250, -150, [
            new Speech({
                content: 'ちなみに、謎の声の名前は<font style="color:#dd0000">ひかり</font>らしいですよ。',
                speakerName: "看板",
            }),
        ]);
        this.pushSignboard(1450, -3350, [
            new Speech({
                content: '押せる壁は"押せるだけ"押したほうがいいかもしれませんね。',
                speakerName: "看板",
            }),
            new Speech({
                content: "たまには最後まで押してみるか。",
            }),
        ]);
        this.pushSignboard(-350, -2150, [
            new Speech({
                content: '<font style="color:#dd0000">自分の大切なものはにぎやかだ。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(-1550, -1550, [
            new Speech({
                content: 'スタート地点のすぐ左には<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>があるらしいですよ。',
            }),
        ]);
        this.pushSignboard(-1050, -50, [
            new Speech({
                content: '<font style="color:#dd0000">自分の大切なものに会いたい。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushDescription(50, -250, 100, 100, "↑");
        this.s$fontSize = 12;
        this.pushDescription(600, -1800, 100, 100, "→");
        this.s$fontSize = 12;

        this.pushGoal(-750, -1550, 100, 100);

        // this.pushCheckPoint(700, -200);
        // this.respawnCheckPoint(1);

        this.create();
    }

    protected loop(): void {}
}
